import React from 'react';
import './App.css';
import Card3D from './Card3D';

function App() {
  return (
    <div className="App">
      <h1 className="heading"><a href="https://julianceddia.com">Julian Ceddia</a></h1>
      <p className="pdflink"><a href="https://firebasestorage.googleapis.com/v0/b/scanbot-46390.appspot.com/o/CV%2FJulian%20Ceddia%20-%20CV.pdf?alt=media&token=3ec276f1-b8c5-4482-8900-0447d83e44a1">Download pdf version</a></p>
      <div className="card-container">
          <Card3D title="Employment">
            {/* Technical Specialist */}
            <h3 className={'indent3'}>
                {"2025 - present {"}
            </h3>
            <h4 className={'indent7'}>
                Postdoctoral Research Fellow<br/>
                <span style={{fontWeight: "normal"}}><em>
                    Monash University, 
                    fixed-term
                </em></span>
            </h4>
            <p  className={'indent11'}>
                My research focuses on <strong>characterising the atomic-scale structural and electronic properties of 2D materials</strong> which have the potential to host <strong>novel and technologically relevant quantum phenomena</strong>.
            </p>
            <p  className={'indent11'}>
                This work utilises <strong>advanced cleanroom nanofabrication techniques</strong> as well as <strong>low-temperature scanning-probe techniques</strong> such as scanning tunnelling microscopy.
            </p>
            
            <h3 className={"indent3"}>{"}"}</h3>
            {/* Technical Specialist */}
            <h3 className={'indent3'}>
                {"2024 - 2025 {"}
            </h3>
            <h4 className={'indent7'}>
                Technical Specialist<br/>
                <span style={{fontWeight: "normal"}}><em>
                    Monash University, 
                    casual,
                    6 months
                </em></span>
            </h4>
            <p  className={'indent11'}>
                The School of Physics at Monash University had recently installed a liquid helium recovery plant.
                I was employed to <strong>develop a real-time database application to log plant activity, enable remote monitoring, and analyse logged data to debug issues related to helium losses</strong>.
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
            
            {/* Gentrack */}
            <h3 className={'indent3'}>
                {"2020 - 2021 {"}
            </h3>
            <h4 className={'indent7'}>
                Software Engineer<br/>
                <span style={{fontWeight: "normal"}}><em>
                    Gentrack, 
                    fixed-term,
                    6 months
                </em></span>
            </h4>
            <p  className={'indent11'}>
                Between finishing my honours and starting my PhD, I was employed on a fixed-term contract to <strong>support the development, testing, and deployment of a major software upgrade</strong> for Actew AGL.
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
            
            {/* Tutor */}
            <h3 className={'indent3'}>
                {"2011 - 2021 {"}
            </h3>
            <h4 className={'indent7'}>
                Tutor<br/>
                <span style={{fontWeight: "normal"}}><em>
                    Self-employed, 
                    10 years
                </em></span>
            </h4>
            <p  className={'indent11'}>
                I started a tutoring business which ran for ten years.
                I tutored students ranging from years two to twelve on a weekly basis and ran exam help sessions for students in their final two years.
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
            
            {/* La Trobe Outreach Ambassador and Tutor */}
            <h3 className={'indent3'}>
                {"2017 - 2019 {"}
            </h3>
            <h4 className={'indent7'}>
                Outreach Ambassador & Tutor<br/>
                <span style={{fontWeight: "normal"}}><em>
                    La Trobe University, casual, 2 years
                </em></span>
            </h4>
            <p  className={'indent11'}>
                I ran weekly laboratory classes for electronic engineering masters students, as well as 
                frequent engineering and physics workshops for secondary school students as part of La Trobe University's outreach program.
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
            
            {/* Electronic Engineering at CTI */}
            <h3 className={'indent3'}>
                {"2017 - 2018 {"}
            </h3>
            <h4 className={'indent7'}>
                Electronic Engineer<br/>
                <span style={{fontWeight: "normal"}}><em>
                    Centre for Technology Infusion (CTI), part-time, 1.5 years
                </em></span>
            </h4>
            <p  className={'indent11'}>
                Responsibilities included <strong>analog and digital circuit design</strong>, as well as <strong>PCB design and layout</strong> (<a href={"https://www.altium.com/"} target={"_blank"} style={{color: '#000000'}}>Altium software</a>).
            </p>
            <p  className={'indent11'}>
                During my employment I worked on developing sensors for a startup company called <a href={"https://www.latrobe.edu.au/industry-and-community/la-trobe-industry/case-studies/sensadata"} target={"_blank"} style={{color: '#000000'}}>SensaData</a>.
                These sensors were designed to monitor the conditions of fresh produce during transit and transmit data in realtime (<strong>Internet of Things</strong>).
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
            
            {/* Gentrack */}
            <h3 className={'indent3'}>
                {"2015 - 2018 {"}
            </h3>
            <h4 className={'indent7'}>
                Software Developer<br/>
                <span style={{fontWeight: "normal"}}><em>
                    Gentrack, full-time (2015 to 2018), part-time (Q1 2018), 3 years
                </em></span>
            </h4>
            <p  className={'indent11'}>
                Provided software solutions to leading energy and utility companies.
            </p>
            <p  className={'indent11'}>
                Responsible for designing, programming, and testing modifications and upgrades to systems, including databases (<strong>Oracle</strong> and <strong>MySQL</strong>), in accordance with <strong>customer-specific business requirements</strong>.
            </p>
            <p  className={'indent11'}>
                In 2016, <strong>I was responsible for designing and delivering</strong> a <em>delegation of authority</em> solution for <a href={"https://www.originenergy.com.au/"} target={"_blank"} style={{color: '#000000'}}>Origin Energy</a>.
                This project was assigned to me after a senior developer unexpectedly went on leave and <strong>I was able to successfully deliver it within the original timeframe</strong>.
            </p>
            <p  className={'indent11'}>
                In 2017, <strong>I led a small team of developers</strong> to deliver an upgrade for Origin energy that implemented the new <a href={"https://aemo.com.au/en/initiatives/major-programs/past-major-programs/nem-power-of-choice"} target={"_blank"} style={{color: '#000000'}}>Power of Choice</a> regulations set by the Australian Energy Market Operator.
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
          </Card3D>
          
          <Card3D title="Education">
            <h3 className={'indent3'}>
                {"2021 - 2024 {"}
            </h3>
            <h4 className={'indent7'}>
                Doctor of Philosophy - Condensed Matter Physics<br/>
                <span style={{fontWeight: "normal"}}><em>ARC Centre of Excellence in Future Low-Energy Electronics Technologies, Monash University Node</em></span>
            </h4>
            <p  className={'indent11'}>
                Comprehensive expertise in <strong>low-temperature scanning tunnelling microscopy</strong> (STM) and <strong>non-contact atomic force microscopy</strong> (nc-AFM).
            </p>
            <p  className={'indent11'}>
                Daily responsibilities included the <strong>safe handling of cryogenic liquids</strong> such as liquid nitrogen and liquid helium.
            </p>
            <p  className={'indent11'}>
                I gained extensive experience working with and troubleshooting <strong>ultra-high vacuum systems (UHV)</strong>.
            </p>
            <p  className={'indent11'}>
                I specialised in synthesising <strong>2D organic and metal-organic frameworks in UHV</strong> and characterising them using STM/STS/nc-AFM on metallic surfaces, <strong>insulating decoupling layers (hBN)</strong>, and <strong>gate-tunable heterostructure architectures</strong>.
            </p>
            <p  className={'indent11'}>
                I acquired broad skills in <a href={"https://julianceddia.com/blog/2023-08-02-cleanroom-creations.html"} target={"_blank"} style={{color: '#000000'}}><strong>micro and nano fabrication techniques</strong></a> through frequent training and use of tools at the Melbourne Centre for Nanofabrication.
                Able to prepare clean, high-quality devices, constructed from <strong>exfoliated materials such as graphene, hBN, and TMDs</strong>, suitable for STM experiments.
            </p>
            <p  className={'indent11'}>
                Capable of <a href={"https://github.com/New-Horizons-SPM/scanbot"} target={"_blank"} style={{color: '#000000'}}><strong>writing software to interface with and automate complex equipment</strong></a> in the lab.
            </p>
            <p  className={'indent11'}>
                I also had the opportunity to <a href={"https://julianceddia.com/blog/2023-10-23-chris.html"} target={"_blank"} style={{color: '#000000'}}><strong>supervise undergrad students</strong></a> during semester-long projects that contribute to their degree.
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
            
            <h3 className={"indent3"}>
                {"2020 {"}
            </h3>
            <h4 className={"indent7"}>
                Bachelor of Science - Honours<br/>
                <span style={{fontWeight: "normal"}}><em>La Trobe University</em></span>
            </h4>
            <p className={"indent11"}>
                First class honours in Physics
            </p>
            <p className={"indent11"}>
                WAM: 91%
            </p>
            <p className={"indent11"}>
                The focus of my honours project was in <strong>x-ray optics</strong>, specifically <a href={"https://julianceddia.com/blog/2020-11-06-honours.html"} target={"_blank"} style={{color: '#000000'}}><strong>recovering the complete coherence function of a synchrotron beam</strong></a> using just three images.
                I attended <strong>three collaborative synchrotron beamtimes</strong> that contributed to the work of two PhD students, one experiment of which was in Taiwan.
                I received La Trobe University's <a href={"https://julianceddia.com/blog/2021-12-15-david-myers-medal.html"} target={"_blank"} style={{color: '#000000'}}><strong>David Myers Medal</strong></a> for achieving the highest mark in my cohort.
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
            
            <h3 className={"indent3"}>
                {"2017 - 2019 {"}
            </h3>
            <h4 className={"indent7"}>
                Bachelor of Science<br/>
                <span style={{fontWeight: "normal"}}><em>La Trobe University</em></span>
            </h4>
            <p className={"indent11"}>
                Major in Physics and Maths
            </p>
            <p className={"indent11"}>
                WAM: 94%
            </p>
            <p className={"indent11"}>
                I was a recipient of La Trobe University's Provost’s Commendation, awarded to <strong>high achieving</strong> students (WAM > 90%)
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
            
            
            <h3 className={"indent3"}>
                {"2011 - 2014 {"}
            </h3>
            <h4 className={"indent7"}>
                Bachelor of Electronic Engineering with Honours<br/>
                <span style={{fontWeight: "normal"}}><em>La Trobe University</em></span>
            </h4>
            <p className={"indent11"}>
                Dean's honour list (WAM > 80% in final year)
            </p>
            <p className={"indent11"}>
                WAM: 76%
            </p>
            <p className={"indent11"}>
                For my final-year engineering project, <strong>I designed and constructed an FPGA-based magnetically levitating train</strong>.
                I was selected to present my project at the annual IEEE Engineering and IT Showcase event and received an award.
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
          </Card3D>
          
          
          {/* Grants and Scholarships */}
          <Card3D title="Grants and Scholarships">
            {/* Stipend Top Up */}
            <h3 className={'indent3'}>
                {"2021 - 2024 {"}
            </h3>
            <h4 className={'indent7'}>
                Monash Graduate Excellence Scholarship<br/>
                <span style={{fontWeight: "normal"}}><em>
                    Monash University, <strong>$10,000 per annum</strong>, 3.5 years
                </em></span>
            </h4>
            <p  className={'indent11'}>
                I was awarded a $10,000/annum top-up scholarship to supplement the regular PhD stipend.
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
            
            {/* Hackathon */}
            <h3 className={'indent3'}>
                {"2024 {"}
            </h3>
            <h4 className={'indent7'}>
                Better Futures Innovation Challenge<br/>
                <span style={{fontWeight: "normal"}}><em>
                    Better Futures, <strong>$10,000</strong> total prize money
                </em></span>
            </h4>
            <p  className={'indent11'}>
                I <a href={"https://www.fleet.org.au/blog/better-futures-industry-challenge-2024/"} target={"_blank"} style={{color: '#000000'}}><strong>competed in a hackathon</strong></a> hosted by Better Futures.
                The challenge was to come up with <strong>novel quantum technology that solves a real-world problem</strong>.
            </p>
            <p  className={'indent11'}>
                We came up with a sensor that leveraged quantum tunnelling to detect extremely small vibrations, with applications in early earthquake detection and mining.
            </p>
            <p  className={'indent11'}>
                Our team made it through to the final round and was awarded $5,000 in grant money to follow through with our idea over six weeks.
                During these six weeks, <strong>the team flew down to Melbourne where we built a prototype of the sensor</strong> in my lab at Monash University.
            </p>
            <p  className={'indent11'}>
                <strong>We ultimately won the challenge and a total of $10,000 in prize money</strong>.
            </p>
            <p  className={'indent11'}>
                As a direct result of this competition, <strong>we are currently receiving mentorship from experts in research translation to take our idea to the next stages of product development and commercialisation</strong>.
                
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
            
            {/* Uplift */}
            <h3 className={'indent3'}>
                {"2023 {"}
            </h3>
            <h4 className={'indent7'}>
                Research Uplift Grant<br/>
                <span style={{fontWeight: "normal"}}><em>
                    Monash University - Faculty of Science, <strong>$3,000</strong>
                </em></span>
            </h4>
            <p  className={'indent11'}>
                Our group was awarded a grant to <strong>fund new lab equipment</strong> related to my PhD project. The application was co-led by Dr. Daniel Moreno.
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
            
            {/* FLEET Translation Project */}
            <h3 className={'indent3'}>
                {"2022 - 2023 {"}
            </h3>
            <h4 className={'indent7'}>
                FLEET Translation Program<br/>
                <span style={{fontWeight: "normal"}}><em>
                    ARC Centre of Excellence in Future Low-Energy Electronics Technologies, <strong>$15,000</strong>, 6 months - 8hr/week
                </em></span>
            </h4>
            <p  className={'indent11'}>
                The FLEET Translation Program funded researchers to develop ideas that could <strong>generate impact beyond their specific area of research</strong>.
                My idea was to automate aspects of the Scanning Tunnelling Microscope (STM) in our lab in a way that is useful to the wider STM community.
            </p>
            <p  className={'indent11'}>
                <strong>I successfully completed the project</strong> on budget within the six-month timeframe; the finished product is open-source and available on <a href={"https://github.com/New-Horizons-SPM/scanbot"} target={"_blank"} style={{color: '#000000'}}>GitHub</a>.
            </p>
            <p  className={'indent11'}>
                As part of the project, <a href={"https://new-horizons-spm.github.io/scanbot/"} target={"_blank"} style={{color: '#000000'}}><strong>I wrote comprehensive documentation</strong></a> for the installation and general use of the STM automation software.
            </p>
            <p  className={'indent11'}>
                I have <strong>submitted a first-author manuscript</strong> that is currently under review in the Journal of Open Source Software.
            </p>
            <p  className={'indent11'}>
                I <strong>presented the project at a conference</strong> in Queensland, Australia
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
            
            {/* AMSI */}
            <h3 className={'indent3'}>
                {"2020 - 2021 {"}
            </h3>
            <h4 className={'indent7'}>
                <a href={"https://julianceddia.com/blog/2020-02-17-bouncing-balls.html"} target={"_blank"} style={{color: '#000000'}}>AMSI Summer Vacation Project</a><br/>
                <span style={{fontWeight: "normal"}}><em>
                    Australian Mathematical Sciences Institute (AMSI), <strong>$3,000</strong>, 3 weeks
                </em></span>
            </h4>
            <p  className={'indent11'}>
                I was <strong>awarded a scholarship</strong> to work on a summer project that modelled a one-dimensional system of a ball bouncing on an oscillating platform.
                This system exhibited a range of rich and complex behaviours, the most notable of which being the phenomenon of period-doubling bifurcations leading to chaos.
            </p>
            <p  className={'indent11'}>
                I <strong>presented the project at a three-day conference</strong> held at Melbourne University, which was attended by the cohort of AMSI scholars from across Australia.
            </p>
            <p  className={'indent11'}>
                I was able to <strong>experimentally reproduce</strong> some of the simulated results by <strong>constructing an oscillating platform from 3D-printed parts and aluminium extrusion</strong>.
                The platform could oscillate at frequencies up to 10 Hz and performed well during a <strong>live demonstration</strong> at the conclusion of the project.
            </p>
            <h3 className={"indent3"}>{"}"}</h3>
          </Card3D>
          
          {/* Publications */}
          <Card3D title="Publications">
            {/* 2025 */}
            <h3 className={'indent3'}>
                {"2025 {"}
            </h3>
            <h4 className={'indent7'}>
                Tunining Interface Electronic Properties via Chiral 2D Metal-Organic Frameworks<br/>
                <span style={{fontWeight: "normal"}}><em>
                    <strong>Julian Ceddia</strong>, Bernard Field, Jack Hellerstedt, Sebastian O. Fürer, Benjamin Lowe, Udo Bach, Sinéad Griffin, Agustin Schiffrin<br/>
                    Small Structures, 2025
                </em></span>
            </h4>
            {/* 2024 */}
            <h3 className={'indent3'}>
                {"2024 {"}
            </h3>
            <h4 className={'indent7'}>
                Scanbot<br/>
                <span style={{fontWeight: "normal"}}><em>
                    <strong>Julian Ceddia</strong>, Jack Hellerstedt, Benjamin Lowe, Agustin Schiffrin<br/>
                    Journal of Open Source Software, 2024
                </em></span>
            </h4>
            <h4 className={'indent7'}>
                Gate control of Mott metal-insulator transition in a 2D metal-organic framework<br/>
                <span style={{fontWeight: "normal"}}><em>
                    Benjamin Lowe, Bernard Field, Jack Hellerstedt, <strong>Julian Ceddia</strong>, Henry L. Nourse, Ben J. Powell, Nikhil V. Medhekar, Agustin Schiffrin<br/>
                    Nature Communications, 2024
                </em></span>
            </h4>
            <h3 className={"indent3"}>{"}"}</h3>
          </Card3D>
      </div>
    </div>
  );
}

export default App;
